import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useCookies } from 'react-cookie'
import { useLocaleActions } from '@merchant-portal/merchant-portal-base'
import { Select, TextInput, PasswordInput, Button } from '@resurs/midas-react'
import { getText } from '../../../internal/TextLabels'
import { format } from '../../../models/format'

const LoginFormNoCookie = props => {
  const [cookies, setCookie] = useCookies(['country'])
  const [country, setCountry] = useState(
    (cookies.country && cookies.country.countryCode) || 'SE',
  )
  const localeActions = useLocaleActions()
  const [store, setStore] = useState('')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  useEffect(() => {
    setCookie('country', { countryCode: country }, { path: '/' })
    localeActions.setCountry(country)
  }, [country])

  return (
    <div>
      <form
        onSubmit={e => props.onLogin(e, { country, store, username, password })}
      >
        <Select
          key={`select-${country}`}
          id="country"
          label={getText('login.selectCountry')}
          value={country}
          onChange={setCountry}
          values={[
            {
              key: 'SE',
              value: 'SE',
              valueLabel: getText('countries.sweden'),
            },
            {
              key: 'FI',
              value: 'FI',
              valueLabel: getText('countries.finland'),
            },
            {
              key: 'DK',
              value: 'DK',
              valueLabel: getText('countries.denmark'),
            },
            {
              key: 'NO',
              value: 'NO',
              valueLabel: getText('countries.norway'),
            },
          ]}
        />
        <TextInput
          id="store"
          type="tel"
          label={props.store}
          format={format.numbers}
          value={store}
          onChange={e => setStore(e.target.value)}
        />
        <TextInput
          id="username"
          label={props.username}
          required={getText('login.required.username')}
          format={format.usernameOrEmail}
          value={username}
          onChange={e => setUsername(e.target.value)}
        />
        <PasswordInput
          id="password"
          label={props.password}
          peekLabel={getText('login.peekPassword')}
          peek
          required={getText('login.required.password')}
          onChange={e => setPassword(e.target.value)}
        />
        <Button
          id="login-button"
          type="primary"
          loading={props.isLoggingIn}
          fullWidth
          form
        >
          {props.loginText}
        </Button>
      </form>
      {props.children}
    </div>
  )
}

LoginFormNoCookie.propTypes = {
  store: PropTypes.string,
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  onLogin: PropTypes.func.isRequired,
  loginText: PropTypes.string.isRequired,
  children: PropTypes.element,
  isLoggingIn: PropTypes.bool.isRequired,
}

LoginFormNoCookie.defaultProps = {
  store: null,
  children: null,
}
export default LoginFormNoCookie
